/* eslint-disable react/display-name */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import angleDown from 'assets/img/newIcons/angle-down.svg'
import angleRight from 'assets/img/newIcons/angle-right.svg'
import angleTop from 'assets/img/newIcons/angle-top.svg'
import event from 'assets/img/newIcons/event.svg'
import eyeOpen from 'assets/img/newIcons/eye-open.svg'
import eye from 'assets/img/newIcons/eye.svg'
import history from 'assets/img/newIcons/history.svg'
import info from 'assets/img/newIcons/info.svg'
import profile from 'assets/img/newIcons/profile.svg'
import search from 'assets/img/newIcons/search.svg'
import burgerMenu from 'assets/img/newIcons/burgerMenu.svg'
import close from 'assets/img/newIcons/close.svg'

// sports

import Bascketball from 'assets/img/newIcons/sports/Bascketball.svg'
import Baseball from 'assets/img/newIcons/sports/Baseball.svg'
import Boxing from 'assets/img/newIcons/sports/Boxing.svg'
import Football from 'assets/img/newIcons/sports/Football.svg'
import Hockey from 'assets/img/newIcons/sports/Hockey.svg'
import Rugby from 'assets/img/newIcons/sports/Rugby.svg'
import Soccer from 'assets/img/newIcons/sports/Soccer.svg'
import Volleyball from 'assets/img/newIcons/sports/Volleyball.svg'

import { StyledCustomIconWrapper } from './customIcon.styles'

const CustomIcon = ({ icon, size = 24, isActive, style, onClick }) => {
  const IconComponent = useMemo(() => {
    switch (icon) {
      case 'angleDown':
        return angleDown
      case 'angleRight':
        return angleRight
      case 'angleTop':
        return angleTop
      case 'event':
        return event
      case 'eyeOpen':
        return eyeOpen
      case 'eye':
        return eye
      case 'history':
        return history
      case 'info':
        return info
      case 'profile':
        return profile
      case 'Search':
        return search
      case 'burgerMenu':
        return burgerMenu
      case 'close':
        return close
      case 'BASKETBALL':
        return Bascketball
      case 'BASEBALL':
        return Baseball
      case 'Boxing':
        return Boxing
      case 'FOOTBALL':
        return Football
      case 'FOOTBALL_NZ':
        return Rugby
      case 'HOCKEY':
        return Hockey
      case 'Rugby':
        return Rugby
      case 'SOCCER':
        return Soccer
      case 'Volleyball':
        return Volleyball
      case 'ATHLETICS':
        return event
      case 'OTHER':
        return event

      default:
        return (props) => <svg {...props} />
    }
  }, [icon])
  return (
    <StyledCustomIconWrapper $isActive={isActive} css={style} onClick={onClick}>
      <IconComponent viewBox="0 0 24 24" width={size} height={size} />
    </StyledCustomIconWrapper>
  )
}

export default CustomIcon

CustomIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  isActive: PropTypes.bool,
  style: PropTypes.shape(),
  onClick: PropTypes.any,
}
